import { render, staticRenderFns } from "./personalForm.vue?vue&type=template&id=bf677984&scoped=true&"
import script from "./personalForm.vue?vue&type=script&lang=js&"
export * from "./personalForm.vue?vue&type=script&lang=js&"
import style0 from "./personalForm.vue?vue&type=style&index=0&id=bf677984&prod&lang=less&"
import style1 from "./personalForm.vue?vue&type=style&index=1&id=bf677984&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf677984",
  null
  
)

export default component.exports